<template>
  <footer>
    <span>{{ this.getCaption('caption.footer') }}</span>
  </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    }
  }
};
</script>
